export const SIZE_INFO_CHANNEL = 'size-info-agreement' as const;

export const SizeInfoAction = {
  AGREE_SIZE_INFO: 'AGREE_SIZE_INFO',
  SELECT_MY_PURCHASE: 'SELECT_MY_PURCHASE',
  COMPARE_DIRECT_INPUT: 'COMPARE_DIRECT_INPUT',
  BODY_PROFILE_UPDATED: 'BODY_PROFILE_UPDATED',
} as const;
